import { ReactNode, useState, useLayoutEffect } from 'react';
import {
  IntlProvider,
  buildIntlProps,
  getCurrentLocale,
  defaultRichTextElements,
} from '@leagueplatform/locales';
import { LeagueConfig, setConfig } from '@leagueplatform/core';

export const TenantIntlProvider = ({
  children,
  systemId,
  config,
}: {
  children: ReactNode;
  systemId: string;
  config: LeagueConfig;
}) => {
  const [intlProps, setIntlProps] = useState(() =>
    buildIntlProps(getCurrentLocale()),
  );

  useLayoutEffect(() => {
    setConfig(config);
    setIntlProps(buildIntlProps(getCurrentLocale()));
  }, [systemId, config]);

  return (
    <IntlProvider
      locale={intlProps.locale}
      messages={intlProps.messages}
      defaultRichTextElements={defaultRichTextElements}
    >
      {children}
    </IntlProvider>
  );
};
